const visibilityPeriods: Array<[number, number]> = [];

function recordHiddenPeriod(time: number): void {
    const last = visibilityPeriods[visibilityPeriods.length - 1];
    if (!last || last[1] !== Infinity) {
        visibilityPeriods.push([time, Infinity]);
    }
}

export function markHidden(): void {
    recordHiddenPeriod(self.performance.now());
}

export function markVisible(): void {
    const now = self.performance.now();
    const last = visibilityPeriods[visibilityPeriods.length - 1];
    if (last && last[1] === Infinity) {
        last[1] = now;
    }
}

export function wasLoafHidden(startTime: number, duration: number): boolean {
    const endTime = startTime + duration;
    const result = visibilityPeriods.some(
        ([hiddenAt, visibleAt]) => startTime < visibleAt && endTime > hiddenAt
    );
    // Trim closed periods that ended before this LoAF started. LoAFs are delivered in
    // chronological order, so no future LoAF can overlap a period that ended before startTime.
    // Keeps the array bounded to at most the last few periods regardless of session length.
    while (visibilityPeriods.length > 0) {
        const [, visibleAt] = visibilityPeriods[0];
        if (visibleAt !== Infinity && visibleAt <= startTime) {
            visibilityPeriods.shift();
        } else {
            break;
        }
    }
    return result;
}

export function resetVisibilityPeriodsForTest(): void {
    visibilityPeriods.length = 0;
    visibilityTrackingInitialized = false;
}

let visibilityTrackingInitialized = false;
export function initVisibilityTracking(
    doc:
        | Pick<Document, 'visibilityState' | 'addEventListener'>
        | undefined = typeof self.document !== 'undefined' ? self.document : undefined
): void {
    if (!doc || visibilityTrackingInitialized) {
        return;
    }
    visibilityTrackingInitialized = true;
    if (doc.visibilityState === 'hidden') {
        recordHiddenPeriod(0);
    }
    doc.addEventListener('visibilitychange', () => {
        doc.visibilityState === 'hidden' ? markHidden() : markVisible();
    });
    doc.addEventListener('freeze', markHidden);
    doc.addEventListener('resume', markVisible);
}
